import { Injectable, Injector } from '@angular/core';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { Mhelpdesk } from '../entities/mhelpdesk';

@Injectable()
export class MhelpdeskService extends BaseCrudService<Mhelpdesk> {

  public uri = '/api/mhelpdesk/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance MhelpdeskService');
  }
 
 getFormatDate() { 
    const url = `${this.rutaServidor}${this.uri}getFormatDate`;
    return this.httpClient.get<Mhelpdesk>(url);
  }
 

  buildSentence(entity?: Mhelpdesk, event?: LazyLoadEvent): HttpParams {
    this.httpParams = new HttpParams();
    if (entity) {
      let query = '';
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Equal}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.group ?
          `group${QueryOperator.Equal}${entity.group}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.name ?
          `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.secondName ?
          `secondName${QueryOperator.Contain}${entity.secondName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.set1 ?
          `set1${QueryOperator.Equal}${entity.set1}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.executingUnit && entity.executingUnit.id) {
        query = query.concat(
          `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }


}



// WEBPACK FOOTER //
// ./src/app/core/services/mhelpdesk.service.ts